// Utilitário para gerar URLs de imagens corretas em dev e produção

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Gera URL correta para imagens com cache-busting agressivo
 * - Em produção: usa /api/uploads/ (roteado pelo Kubernetes Ingress)
 * - Em desenvolvimento: usa BACKEND_URL completo
 * - Se já for URL completa (http), mantém como está
 * - SEMPRE adiciona cache busting com timestamp + random para evitar problemas de Cloudflare
 */
export const getImageUrl = (filename, bustCache = true) => {
  // Se não tem filename, retorna vazio
  if (!filename) return '';
  
  // Se já é uma URL completa (http/https), retorna como está
  if (filename.startsWith('http')) {
    // Para URLs externas, adicionar cache busting se solicitado
    if (bustCache) {
      const separator = filename.includes('?') ? '&' : '?';
      // Usar timestamp + random para garantir URLs únicas
      return `${filename}${separator}t=${Date.now()}&r=${Math.random().toString(36).substring(7)}`;
    }
    return filename;
  }
  
  // Se começa com /uploads/, atualizar para /api/uploads/
  if (filename.startsWith('/uploads/')) {
    filename = filename.replace('/uploads/', '');
  }
  
  // Se começa com /api/uploads/, já está no formato correto
  if (filename.startsWith('/api/uploads/')) {
    if (bustCache) {
      const separator = filename.includes('?') ? '&' : '?';
      return `${filename}${separator}t=${Date.now()}&r=${Math.random().toString(36).substring(7)}`;
    }
    return filename;
  }
  
  // Para filenames simples (sem prefixo)
  let url;
  
  // Em produção: usar /api/uploads/ para compatibilidade com Ingress
  if (BACKEND_URL && !BACKEND_URL.includes('localhost')) {
    url = `/api/uploads/${filename}`;
  } else {
    // Em desenvolvimento: usar BACKEND_URL completo
    url = `${BACKEND_URL}/api/uploads/${filename}`;
  }
  
  // SEMPRE adicionar cache busting agressivo para evitar problemas de CDN
  if (bustCache) {
    return `${url}?t=${Date.now()}&r=${Math.random().toString(36).substring(7)}`;
  }
  
  return url;
};

export default getImageUrl;
